import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom';

import Prompt from './Prompt/Prompt';
import PromptWrapper from './Prompt/Wrapper';
import PromptActions from './Prompt/Actions';

import { useAppContext } from '../../Context/App/Provider';
import { decodeHTMLEntities } from '../../Functions/utils';

import { toastTimerValue } from '../../Shared/utils';

import '../SweetAlert.css'


export default function NoFavoriteLocationAlert({ setNoFavoriteLocationAlertPrompt }) {
  const history = useHistory();
  const { t } = useTranslation();
  const [{ user }, appDispatch] = useAppContext();


  return (
    <Prompt animated>
      <div className="prompt__container animated" style={{ height: '50%' }}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('settings.activity_notifications.unexpected_activity_notifications')}</h1>
            <br />
            <p>{t('settings.activity_notifications.no_favorite_location')}</p>
            <br />
            <p>{t('settings.activity_notifications.no_favorite_location_please_click')}</p>

          </div>
        </PromptWrapper>

        <PromptActions column>
          <Button
            className="btnPrimary"            
            onClick={() => {  
              setNoFavoriteLocationAlertPrompt(false)
              sessionStorage.setItem('noFavoriteLocationPrompted', true);           
              history.push("/admin/locations");
            }}
          >{t('settings.activity_notifications.go_to_admin_locations')}</Button>

          <Button
            className="btnDismiss"
            onClick={() => {
              setNoFavoriteLocationAlertPrompt(false)
              sessionStorage.setItem('noFavoriteLocationPrompted', true);
            }}
          // there should be no parameters passed to the function
          >
            {t('settings.activity_notifications.remind')}
          </Button>
        </PromptActions>
      </div>
    </Prompt>
  )
}
